import React from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'
import config from '../../config'
import { SIZES } from '../../styles/theme'

const Page = styled.div`
  min-height: 100vh;
  height: 100vh;
  background-image: url(${config.assets.register.landscape});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  color: #ffffff;
  padding-bottom: 4.5em;
  padding-top: 3em;
  text-transform: uppercase;

  #message {
    background-color: rgba(255, 255, 255, 0.65);
    border: none;
    border-radius: 12px;
    color: #000000;
    margin: 0 auto;
    padding: 1.5rem 2rem;
    text-align: center;
    .icon {
      width: 100px;
      margin: 0 auto;
    }
    h5 {
      font-weight: 600;
      font-size: 18px;
    }
  }

  .thank-you {
    padding: 2.5em 0;
    position: absolute;
    left: 37%;
    right: 32%;
    top: 12%;

    ${SIZES.mobile} {
      margin-top: 19%;
      position: initial;
    }
  }
  ${SIZES.mobile} {
    padding: 1em 0;
    background-image: url(${config.assets.register.portrait});
    background-size: 100% 100%;
    .mobile-hide {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    img#banner-portrait {
      display: block;
    }
    #message {
      font-size: 0.75em;
      padding: 1.5rem 1rem;
      width: 85%;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%;
    }
  }
`

export default function PostRegisterPage() {
  return (
    <Page>
      <Row noGutters className="h-100 thank-you">
        <Col md={12}>
          <div id="message">
            <h5>Thank you for your registration and you will receive a confirmation email soon.</h5>
          </div>
        </Col>
      </Row>
    </Page>
  )
}
